import React, { ReactNode, createElement } from "react";

export interface SlotProps {
  children: ReactNode;
  id?: string;
  host?: keyof JSX.IntrinsicElements | "fragment";
}

const Slot: React.FC<SlotProps> = ({ children, id, host = "div" }) => {
  return host === "fragment" ? <>{children}</> : createElement(host, { id, className: "slot" }, children);
};

export { Slot };
